import "./VideoShowcase.scss";

// code imports
import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Reveal from "../../common/UI_Elements/Reveal";
import useLazyBackground from "../../common/useLazyBackground";

const VIDEO_THUMBNAIL = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/trailer_thumbnail_v1.webp";
const VIDEO_THUMBNAIL_MOBILE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/trailer_thumbnail_mobile.png";
const YOUTUBE_ID = "9GXDH683fmQ";
const YOUTUBE_EMBED = `https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
const isPhone = () => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
const VIDEO_DURATION = "0:57"; // placeholder: update with the real trailer length

function VideoModal({ onClose }) {
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        document.addEventListener("keydown", onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [onClose]);

    return createPortal(
        <div className="VideoModal" role="dialog" aria-modal="true" aria-label="Hitwicket trailer" onClick={onClose}>
            <button type="button" className="VideoModal-close" aria-label="Close video" onClick={onClose}>
                &times;
            </button>
            <iframe
                className="VideoModal-video"
                src={YOUTUBE_EMBED}
                title="Hitwicket trailer"
                allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                allowFullScreen
                onClick={(e) => e.stopPropagation()}
            />
        </div>,
        document.body
    );
}

function VideoShowcase() {
    const [open, setOpen] = useState(false);
    const [inline, setInline] = useState(false); // phones play in place instead of opening the overlay
    const close = useCallback(() => setOpen(false), []);
    const bgRef = useLazyBackground(".VideoShowcaseWrap");

    return (
        <Reveal className="VideoShowcaseWrap col-12 px-0">
            <div className="VideoShowcase" ref={bgRef}>
            <div className="VideoShowcase-grid">
                <div className="VideoShowcase-media">
            {inline ? (
                <div className="VideoShowcase-embed">
                    <iframe
                        src={YOUTUBE_EMBED}
                        title="Hitwicket trailer"
                        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                        allowFullScreen
                    />
                </div>
            ) : (
            <button
                type="button"
                className="VideoShowcase-player"
                onClick={() => (isPhone() ? setInline(true) : setOpen(true))}
                aria-label={`Play trailer, ${VIDEO_DURATION}`}
            >
                <picture>
                    <source media="(max-width: 767px)" srcSet={VIDEO_THUMBNAIL_MOBILE} width="513" height="288" />
                    <img src={VIDEO_THUMBNAIL} width="1920" height="1080" alt="Hitwicket trailer thumbnail" />
                </picture>
                <span className="VideoShowcase-play">
                    <span className="VideoShowcase-triangle" />
                </span>
                <span className="VideoShowcase-trailerLabel">OFFICIAL GAME TRAILER</span>
                <span className="VideoShowcase-duration">{VIDEO_DURATION}</span>
            </button>
            )}
                </div>

                <div className="VideoShowcase-text">
                    <h2 className="SectionHeading VideoShowcase-title text-white fw-bold">
                        <span className="is-silver">ABOUT</span> <span className="is-gold">HITWICKET</span>
                    </h2>
                    <p>
                        Experience the thrill of cricket with <b>Sachin Tendulkar</b> and Hitwicket, and discover next-generation cricket gaming, made in India! Join <b>20M+ players</b> worldwide, build your dream squad with 50+ unique characters, participate in player auctions, train and upgrade players, and craft winning strategies. Compete in exciting game modes and live events, join alliances, and challenge friends as you rise through the ranks!
                    </p>
                </div>
            </div>

            {open && <VideoModal onClose={close} />}
            </div>
        </Reveal>
    );
}

export default VideoShowcase;
